import { render, staticRenderFns } from "./GoodTable.vue?vue&type=template&id=712c8c9e"
import script from "./GoodTable.vue?vue&type=script&lang=js"
export * from "./GoodTable.vue?vue&type=script&lang=js"
import style0 from "./GoodTable.vue?vue&type=style&index=0&id=712c8c9e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports